const authConfig = {
	clientId: process.env.REACT_APP_CLIENT_ID,
	clientSecret: process.env.REACT_APP_CLIENT_SECRET,
	tokenEndpoint: process.env.REACT_APP_TOKEN_ENDPOINT
};

export default authConfig;
